import { Navigate, Route, Routes, useLocation, useSearchParams } from 'react-router-dom';

import DetailsPage from 'App/DetailsPage/DetailsPage';
import ListPage from 'App/ListPage/ListPage';

import { messageExchangeConfig, postMxMessage } from '../utils/message-exchange.utils';
import { DetailRedirect, NoMatchRoute } from './handlers/handlers';

const AppRoutes: React.FC = () => {
  const [searchParams] = useSearchParams();
  const locationHash = useLocation().hash;
  const hashTrackingIds = locationHash.match(/id=([\w\d,]+)/);
  const queryParamIds = searchParams.get('id') || (hashTrackingIds && hashTrackingIds[1]) || '';
  const trackingIdsArray = queryParamIds?.split(/[\s,]+/).filter((trackingId) => trackingId);
  const singleTrackingId = trackingIdsArray?.length === 1 && trackingIdsArray[0];

  if (singleTrackingId) {
    postMxMessage(messageExchangeConfig.queryTrackingId, {});
    return <Navigate to={`/details/${singleTrackingId}`} />;
  }

  return (
    <Routes>
      <Route path='search' element={<ListPage />} />
      <Route path='details/:trackingId' element={<DetailsPage />} />
      <Route path='article/:trackingId' element={<DetailRedirect />} />
      <Route path='*' element={<NoMatchRoute />} />
    </Routes>
  );
};

export default AppRoutes;
